type BadgeProps = {
  className?: string;
};

const baseClass =
  "inline-flex items-center gap-3 rounded-xl bg-secondary px-4 py-2.5 text-secondary-foreground shadow-soft transition-all hover:scale-[1.03] hover:shadow-elegant focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2";

export const AppStoreBadge = ({ className = "" }: BadgeProps) => (
  <a
    href="https://apps.apple.com/us/app/freecrm-com/id6757925489"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Download FreeCRM on the App Store"
    className={`${baseClass} ${className}`}
  >
    <svg viewBox="0 0 384 512" className="h-7 w-7" fill="currentColor" aria-hidden="true">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zM256.8 84.8c20.7-24.5 18.8-46.8 18.2-54.8-18.3 1.1-39.5 12.5-51.6 26.5-13.3 15-21.1 33.6-19.4 54.4 19.8 1.5 37.9-8.7 52.8-26.1z"/>
    </svg>
    <span className="flex flex-col leading-tight">
      <span className="text-[10px] uppercase tracking-wide opacity-80">Download on the</span>
      <span className="text-base font-semibold">App Store</span>
    </span>
  </a>
);

export const GooglePlayBadge = ({ className = "" }: BadgeProps) => (
  <a
    href="https://play.google.com/store/apps/details?id=com.freecrm"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Get FreeCRM on Google Play"
    className={`${baseClass} ${className}`}
  >
    <svg viewBox="0 0 512 512" className="h-7 w-7" aria-hidden="true">
      <path fill="#EA4335" d="M325.3 234.3 104.6 13l280.8 161.2z"/>
      <path fill="#FBBC04" d="m104.6 13 220.7 221.3-220.7 220.9z"/>
      <path fill="#4285F4" d="M104.6 454.9 325.3 234.3l60.1 60.1z"/>
      <path fill="#34A853" d="M385.4 174.2 484 230.5c14.7 8.4 14.7 29.7 0 38.2l-98.6 56.6-66.1-65.6z"/>
    </svg>
    <span className="flex flex-col leading-tight">
      <span className="text-[10px] uppercase tracking-wide opacity-80">Get it on</span>
      <span className="text-base font-semibold">Google Play</span>
    </span>
  </a>
);

// Compact icon-only variants for navbar
export const AppStoreIconBadge = ({ className = "" }: BadgeProps) => (
  <a
    href="https://apps.apple.com/us/app/freecrm-com/id6757925489"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Download FreeCRM on the App Store"
    title="iOS App"
    className={`inline-flex h-9 w-9 items-center justify-center rounded-lg bg-secondary text-secondary-foreground transition-all hover:scale-110 ${className}`}
  >
    <svg viewBox="0 0 384 512" className="h-5 w-5" fill="currentColor" aria-hidden="true">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zM256.8 84.8c20.7-24.5 18.8-46.8 18.2-54.8-18.3 1.1-39.5 12.5-51.6 26.5-13.3 15-21.1 33.6-19.4 54.4 19.8 1.5 37.9-8.7 52.8-26.1z"/>
    </svg>
  </a>
);

export const GooglePlayIconBadge = ({ className = "" }: BadgeProps) => (
  <a
    href="https://play.google.com/store/apps/details?id=com.freecrm"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Get FreeCRM on Google Play"
    title="Android App"
    className={`inline-flex h-9 w-9 items-center justify-center rounded-lg bg-secondary transition-all hover:scale-110 ${className}`}
  >
    <svg viewBox="0 0 512 512" className="h-5 w-5" aria-hidden="true">
      <path fill="#EA4335" d="M325.3 234.3 104.6 13l280.8 161.2z"/>
      <path fill="#FBBC04" d="m104.6 13 220.7 221.3-220.7 220.9z"/>
      <path fill="#4285F4" d="M104.6 454.9 325.3 234.3l60.1 60.1z"/>
      <path fill="#34A853" d="M385.4 174.2 484 230.5c14.7 8.4 14.7 29.7 0 38.2l-98.6 56.6-66.1-65.6z"/>
    </svg>
  </a>
);
